import { render, staticRenderFns } from "./sayer.vue?vue&type=template&id=72a97e89&scoped=true&"
import script from "./sayer.vue?vue&type=script&lang=js&"
export * from "./sayer.vue?vue&type=script&lang=js&"
import style0 from "./sayer.vue?vue&type=style&index=0&id=72a97e89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a97e89",
  null
  
)

export default component.exports